import React from "react";
import { booleanOptions } from "../../../shared/constants/dropdown-options";
import { advancedFiltersFields, basicOptions } from "../../task-list/lib/constants";
import { SHIPMENT_FILTER_TYPES } from "../../shipments/lib/constants";
import { Controller } from "react-hook-form";
import { DatePicker, Select, Textarea } from "../../form-inputs/inputs";
import { PRIORITY_LEVELS } from "../../../admin/assignment/lib/constants";
import { useAdvancedFiltersForm } from "../../../shared/hooks/use-advanced-filters-form";
import MultiSelectList from "../../form-inputs/custom/react-multi-select";
import { useClients } from "../hooks/use-clients";
import { useSettings } from "../../../shared/hooks/use-settings";

export const ImageEditingQa = () => {
    const {
        control,
        findDefaultValues,
        updateTeamAssignments,
        updateUserAssignments,
        userAssignmentOptions,
        assignmentOptions,
        locations,
        statusTypes,
    } = useAdvancedFiltersForm();
    const { data: cxhClients } = useClients(3);
    const { data: clients } = useClients(2);
    const { settings } = useSettings();

    return (
        <>
            <div className="flex-column">
                <div className="advanced-filters-row">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.priority.label}</div>
                    <Controller
                        name={advancedFiltersFields.priority.name}
                        control={control}
                        render={({ field }) => {
                            return (
                                <Select
                                    {...field}
                                    excludeSelect
                                    className="flex-2 advanced-filters-field"
                                    options={[
                                        { text: " ", value: "" },
                                        ...PRIORITY_LEVELS,
                                        {
                                            text: "≠",
                                            value: "null",
                                        },
                                    ]}
                                />
                            );
                        }}
                    />
                </div>
                <div className="advanced-filters-row">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.isRush.label}</div>
                    <Controller
                        name={advancedFiltersFields.isRush.name}
                        control={control}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="flex-2 advanced-filters-field"
                                options={booleanOptions}
                            />
                        )}
                    />
                </div>
                <div className="advanced-filters-row">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.hasPremiumEditing.label}</div>
                    <Controller
                        name={advancedFiltersFields.hasPremiumEditing.name}
                        control={control}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="flex-2 advanced-filters-field"
                                options={booleanOptions}
                            />
                        )}
                    />
                </div>
                <div className="advanced-filters-row">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.isFoodService.label}</div>
                    <Controller
                        name={advancedFiltersFields.isFoodService.name}
                        control={control}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="flex-2 advanced-filters-field"
                                options={booleanOptions}
                            />
                        )}
                    />
                </div>
                <div className="advanced-filters-row">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.clientApproval.label}</div>
                    <Controller
                        name={advancedFiltersFields.clientApproval.name}
                        control={control}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="flex-2 advanced-filters-field"
                                options={booleanOptions}
                            />
                        )}
                    />
                </div>
                <div className="advanced-filters-row">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.locationDataSource.label}</div>
                    <Controller
                        name={advancedFiltersFields.locationDataSource.name}
                        control={control}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="flex-2 advanced-filters-field"
                                options={settings.locationDataSources}
                            />
                        )}
                    />
                </div>
                <div className="advanced-filters-row">
                    <div className="advanced-filters-name flex-1">Due Date</div>
                    <div className="flex flex-2 advanced-filters-field">
                        <Controller
                            name={advancedFiltersFields.startDate.name}
                            control={control}
                            render={({ field }) => {
                                return (
                                    <DatePicker
                                        className="m-r-16"
                                        emitAsString
                                        isClearable
                                        label="From"
                                        name={field.name}
                                        value={field.value}
                                        updateOnChange={(name, value) => field.onChange(value)}
                                        enableIcon
                                    />
                                );
                            }}
                        />
                        <Controller
                            name={advancedFiltersFields.endDate.name}
                            control={control}
                            render={({ field }) => (
                                <DatePicker
                                    className="m-l-16"
                                    emitAsString
                                    isClearable
                                    label="To"
                                    name={field.name}
                                    enableIcon
                                    value={field.value}
                                    updateOnChange={(name, value) => field.onChange(value)}
                                />
                            )}
                        />
                    </div>
                </div>
                <div className="advanced-filters-row -align-start">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.client.label}</div>
                    <Controller
                        name={advancedFiltersFields.client.name}
                        control={control}
                        render={({ field }) => {
                            return (
                                <div className="flex-2 advanced-filters-field">
                                    <MultiSelectList
                                        autoCloseClassName=".advanced-filters-body"
                                        defaultValue={findDefaultValues(clients, field.value)}
                                        name="Client"
                                        options={clients}
                                        updateOnChange={(name, values) => field.onChange(values)}
                                        showPagination={false}
                                        clearSelections={field.value === ""}
                                    />
                                </div>
                            );
                        }}
                    />
                </div>
                <div className="advanced-filters-row -align-start">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.cxhClient.label}</div>
                    <Controller
                        name={advancedFiltersFields.cxhClient.name}
                        control={control}
                        render={({ field }) => {
                            return (
                                <div className="flex-2 advanced-filters-field">
                                    <MultiSelectList
                                        autoCloseClassName=".advanced-filters-body"
                                        defaultValue={findDefaultValues(cxhClients, field.value)}
                                        name="CES Client"
                                        options={cxhClients}
                                        updateOnChange={(name, values) => field.onChange(values)}
                                        clearSelections={field.value === ""}
                                    />
                                </div>
                            );
                        }}
                    />
                </div>
                <div className="advanced-filters-row -align-start">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.binTrackingNumber.label}</div>
                    <Controller
                        name={advancedFiltersFields.binTrackingNumber.name}
                        control={control}
                        render={({ field }) => (
                            <Textarea
                                {...field}
                                className="flex-2 advanced-filters-field"
                            />
                        )}
                    />
                </div>
                <div className="advanced-filters-row -align-start">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.upc.label}</div>
                    <Controller
                        name={advancedFiltersFields.upc.name}
                        control={control}
                        render={({ field }) => (
                            <Textarea
                                {...field}
                                className="flex-2 advanced-filters-field"
                            />
                        )}
                    />
                </div>
                <div className="advanced-filters-row -align-start">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.description.label}</div>
                    <Controller
                        name={advancedFiltersFields.description.name}
                        control={control}
                        render={({ field }) => (
                            <Textarea
                                {...field}
                                className="flex-2 advanced-filters-field"
                            />
                        )}
                    />
                </div>
                <div className="advanced-filters-row -align-start">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.location.label}</div>
                    <Controller
                        name={advancedFiltersFields.location.name}
                        control={control}
                        render={({ field }) => {
                            return (
                                <div className="flex-2 advanced-filters-field">
                                    <MultiSelectList
                                        autoCloseClassName=".advanced-filters-body"
                                        defaultValue={findDefaultValues(locations, field.value)}
                                        name="Location"
                                        options={locations}
                                        updateOnChange={(name, values) => field.onChange(values)}
                                        clearSelections={field.value === ""}
                                    />
                                </div>
                            );
                        }}
                    />
                </div>
                <div className="advanced-filters-row">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.state.label}</div>
                    <Controller
                        name={advancedFiltersFields.state.name}
                        control={control}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="flex-2 advanced-filters-field"
                                excludeSelect
                                value={(field && field.value) || ""}
                                options={statusTypes}
                            />
                        )}
                    />
                </div>
                <div className="advanced-filters-row">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.assignmentGroupKey.label}</div>
                    <Controller
                        name={advancedFiltersFields.assignmentGroupKey.name}
                        control={control}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="flex-2 advanced-filters-field"
                                value={(field && field.value) || ""}
                                excludeSelect
                                options={[...basicOptions, ...assignmentOptions]}
                                onChange={(event) => {
                                    const value = event.target.value;
                                    updateTeamAssignments(value, true);
                                    field.onChange(event.target.value);
                                }}
                            />
                        )}
                    />
                </div>
                <div className="advanced-filters-row">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.assignedUserInfo.label}</div>
                    <Controller
                        name={advancedFiltersFields.assignedUserInfo.name}
                        control={control}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="flex-2 advanced-filters-field"
                                value={(field && field.value) || ""}
                                excludeSelect
                                options={[...basicOptions, ...userAssignmentOptions]}
                                onChange={(event) => {
                                    const value = event.target.value;

                                    updateUserAssignments(value, true);
                                    field.onChange(event.target.value);
                                }}
                            />
                        )}
                    />
                </div>
                <div className="advanced-filters-row">
                    <div className="advanced-filters-name flex-1">{advancedFiltersFields.shipmentType.label}</div>
                    <Controller
                        name={advancedFiltersFields.shipmentType.name}
                        control={control}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="flex-2 advanced-filters-field"
                                value={(field && field.value) || ""}
                                excludeSelect
                                options={SHIPMENT_FILTER_TYPES}
                            />
                        )}
                    />
                </div>
            </div>
        </>
    );
};
